var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailureemoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_924_2237)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.0006,
    cy: 59.9996,
    r: 59.4,
    fill: "#FFE4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1402 52.0793C54.4208 52.0793 57.0802 48.5334 57.0802 44.1593C57.0802 39.7852 54.4208 36.2393 51.1402 36.2393C47.8596 36.2393 45.2002 39.7852 45.2002 44.1593C45.2002 48.5334 47.8596 52.0793 51.1402 52.0793Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8209 44.1593C86.1014 44.1593 88.7609 40.6134 88.7609 36.2393C88.7609 31.8652 86.1014 28.3193 82.8209 28.3193C79.5403 28.3193 76.8809 31.8652 76.8809 36.2393C76.8809 40.6134 79.5403 44.1593 82.8209 44.1593Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0006 0.599609C32.2474 0.599609 5.60059 27.2465 5.60059 59.9996C5.60059 85.9158 22.2905 107.995 45.4816 116.089C46.0298 116.308 46.5842 116.495 47.1457 116.653C52.7841 118.434 58.7813 119.4 65.0006 119.4C97.7537 119.4 124.401 92.7528 124.401 59.9996C124.401 27.2465 97.7537 0.599609 65.0006 0.599609ZM43.5358 103.756L42.707 101.497C40.9229 96.6323 40.2861 91.34 40.8656 86.1921L40.9706 85.2627L36.5575 73.2313C36.1933 72.2381 36.2378 71.163 36.6825 70.2033C37.1265 69.2436 37.9187 68.514 38.912 68.1498C39.3567 67.9868 39.8175 67.9055 40.2771 67.9055C40.8443 67.9055 41.4095 68.0293 41.9394 68.2748C42.8992 68.7195 43.6287 69.511 43.9929 70.5043L45.826 75.4994C46.7928 78.1375 48.7296 80.2413 51.2793 81.422C53.8285 82.6034 56.6856 82.7208 59.3231 81.7533L88.4843 71.0567C89.5098 70.6836 90.6492 71.2094 91.025 72.2336C91.4015 73.2591 90.873 74.3986 89.8481 74.775L82.6449 77.417C80.1003 78.3503 78.0714 80.2188 76.9318 82.6783C75.7922 85.1377 75.6795 87.8932 76.6128 90.4384L76.9962 91.4839C77.7812 93.625 77.6859 95.944 76.7275 98.0136C75.7684 100.083 74.0617 101.655 71.9199 102.441L54.4931 108.833C52.8582 109.432 51.1568 109.495 49.5786 109.117C49.0881 108.963 48.6053 108.792 48.1211 108.623C46.0676 107.72 44.3674 106.023 43.5358 103.756ZM71.3982 111.068L74.6473 109.876C78.7749 108.362 82.0651 105.331 83.913 101.342C85.7616 97.3534 85.9453 92.8836 84.4313 88.756L84.0478 87.7105C83.8428 87.1518 83.868 86.5472 84.118 86.007C84.3682 85.4676 84.8135 85.057 85.3723 84.852L92.5755 82.2101C97.6995 80.3307 100.34 74.6323 98.4607 69.5064C96.5807 64.3824 90.883 61.7417 85.7571 63.6212L56.5952 74.3178C55.9442 74.5575 55.2379 74.5273 54.6081 74.2359C53.9783 73.944 53.5001 73.4245 53.261 72.7722L51.428 67.7764C49.1727 61.6269 42.3368 58.4559 36.1842 60.7143C33.2052 61.8067 30.8295 63.9943 29.4959 66.874C28.1618 69.7532 28.029 72.9797 29.1221 75.9587L32.8996 86.2582C32.4506 91.3103 32.9552 96.448 34.3445 101.328C21.7175 91.9382 13.5206 76.9093 13.5206 59.9996C13.5206 31.6131 36.6141 8.51961 65.0006 8.51961C93.3871 8.51961 116.481 31.6131 116.481 59.9996C116.481 86.2184 96.7744 107.906 71.3982 111.068Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3328 28.5229L46.4528 24.5629C44.3761 23.8681 42.1344 24.9929 41.4435 27.0676C40.752 29.1424 41.8734 31.3854 43.9482 32.0769L55.8282 36.0369C56.2439 36.1755 56.6661 36.2412 57.0811 36.2412C58.7389 36.2412 60.2845 35.1913 60.8375 33.5323C61.529 31.4576 60.4075 29.2145 58.3328 28.5229Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1211 21.5597C68.5742 23.1059 68.5742 25.6131 70.1211 27.1594C71.6667 28.7063 74.1752 28.7063 75.7208 27.1594C78.5451 24.3363 83.1368 24.3363 85.9611 27.1594C86.734 27.9328 87.7477 28.3195 88.761 28.3195C89.7742 28.3195 90.788 27.9328 91.5608 27.1594C93.1077 25.6131 93.1077 23.1059 91.5608 21.5597C85.6505 15.6481 76.0314 15.6481 70.1211 21.5597Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8799 52.1977L64.0399 56.1577C61.9182 56.6882 60.6277 58.8383 61.1582 60.9601C61.6081 62.7596 63.2227 63.9603 64.9971 63.9603C65.3154 63.9603 65.6383 63.9223 65.9607 63.8418L81.8007 59.8818C83.9224 59.3513 85.2129 57.2011 84.6823 55.0794C84.1518 52.9569 81.9991 51.6691 79.8799 52.1977Z",
    fill: "#514C9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_924_2237",
    x: 0.320586,
    y: 0.599609,
    width: 124.08,
    height: 124.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.28,
    dy: 5.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.298039 0 0 0 0 0.623529 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_924_2237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_924_2237",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureemoji);
export default __webpack_public_path__ + "static/media/failureemoji.a1e19fd8fd1e55f4e18f78efb7974528.svg";
export { ForwardRef as ReactComponent };